import React, {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

import { CloseIcon, MobileSearchIcon } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { ClientSuggest } from 'components';
import { ClientModal } from 'modals';
import { IUser } from 'types';

import s from '../Header.module.scss';

const ClientSearchForMobile: FC<{
  setNotPermissionModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsDepositOpen?: Dispatch<SetStateAction<boolean>>;
  setIsDefaultClient?: Dispatch<SetStateAction<string | undefined>>;
  setIsResetPasswordModal?: Dispatch<SetStateAction<boolean | undefined>>;
  setCurrentClient?: Dispatch<SetStateAction<IUser | undefined>>;
  withReplenishment?: boolean;
}> = ({
  setNotPermissionModalOpen,
  setIsResetPasswordModal,
  setCurrentClient,
  setIsDefaultClient,
  setIsDepositOpen,
  withReplenishment,
}) => {
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const [isVisible, setIsVisible] = useState(false);
  const [clientUUID, setClientUUID] = useState<string | null>(null);

  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const closeMenu = (e: Event): void => {
      if ((e.target as HTMLButtonElement).classList.contains(s.search_modal)) {
        return;
      }

      setIsVisible(false);
    };
    const closeMenuEsc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        setIsVisible(false);
      }
    };

    document.addEventListener('click', closeMenu);
    document.addEventListener('keydown', closeMenuEsc);

    return () => {
      document.removeEventListener('click', closeMenu);
      document.removeEventListener('keydown', closeMenuEsc);
    };
  }, [isVisible]);

  return (
    <>
      {clientUUID && (
        <ClientModal
          clientUUID={clientUUID}
          onClose={() => setClientUUID(null)}
          setIsDepositOpen={setIsDepositOpen}
          setIsDefaultClient={setIsDefaultClient}
          setIsResetPasswordModal={setIsResetPasswordModal}
          setCurrentClient={setCurrentClient}
        />
      )}
      <div
        className={s.search_mobile}
        onClick={() => {
          setIsVisible((prev) => !prev);
        }}
      >
        {isVisible ? <CloseIcon size="m" /> : <MobileSearchIcon size="m" />}
        {isVisible && (
          <div
            className={s.search_modal}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <ClientSuggest
              value={clientUUID}
              onChange={(value) => {
                if (!permissions?.has('client_info')) {
                  clientUUID === '' ? setClientUUID(null) : setClientUUID('');
                  setNotPermissionModalOpen(true);
                  return;
                }

                setClientUUID(value);
              }}
              className={s['client-search_mobile']}
              showBorder
              small
              withReplenishment={withReplenishment}
              setIsDefaultClient={setIsDefaultClient}
              setDepositOpen={setIsDepositOpen}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ClientSearchForMobile;
